import { render, staticRenderFns } from "./editLezione.vue?vue&type=template&id=4a4ba310&"
import script from "./editLezione.vue?vue&type=script&lang=ts&"
export * from "./editLezione.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports